<template>
    <v-app id="landingPage" key="landingPage">
        <header class="header header_mob">
            <div id="menu-scroll">
                <div class="container_yo" id="header_bar">
                    <div class="logo">
                        <a class="logo-image" href="https://yoclass.vn/#/LandingPage">
                            <img src="/home/images/logo.png" alt="logo">
                        </a>
                    </div>
                    <!--div class="shadow" id="shad">
                    </div-->
                    <nav id="navbar-menu" style="width: 100%">
                        <ul class="menu-list">
                            <li class="menu-item hideInMobile">
                                <a href="#" title="Học">Giải pháp</a>
                            </li>
                            <li class="menu-item hideInMobile">
                                <a href="#" title="Giá dịch vụ">Giá dịch vụ</a>
                            </li>
                            <li class="menu-item hideInMobile">
                                <a href="#" title="Liên hệ">Liên hệ</a>
                            </li>
                            <!-- Khi chưa đăng nhập dùng menu dưới bỏ style="display:none;" -->
                            <li id="userLogo" class="menu-item" style="position: absolute;top: 2px;right: 10px">
                                <v-btn small outlined fab color="white"  @click="login">
                                    <v-icon dark>person</v-icon>
                                </v-btn>
                            </li>
                            <li class="menu-item hideInMobile" style="float: right;border-bottom: 3px solid #FFA60D">
                                <a href="/#/login" title="Đăng ký">
                                    <span>Đăng nhập / Đăng ký</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>

        <div class="block_slideshow_home"
             style="background: url('/home/images/background.png');color:white; background-size: cover;">
            <div class="container_yo">
                <v-layout wrap style="margin-top: 140px">
                    <v-flex xs12 sm12 md6 lg6 xl6>
                        <div class="hot-corner_title">
                            <p class="title-1st fade-in">Bạn là giáo viên?</p>
                            <p class="content-1st">YOCLASS LÀ CÔNG CỤ QUẢN LÝ LỚP HỌC OFFLINE HIỆU
                                QUẢ DÀNH CHO GIÁO VIÊN THỜI ĐẠI MỚI </p>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm12 md6 lg6 xl6 class="hideInMobile">
                        <a href="#" class="hideInMobile"><img
                                src="/home/images/anh1b.png" id="anh1b" style="width: 90%"></a>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6>
                        <div id="title">
                            <div class="group_content">
                                <ul class="icon" style="padding-left: 0px">
                                    <li class="title1"><a>Số hóa quá trình tạo đề - làm bài - chấm bài - báo
                                        cáo kết quả sau bài tập giúp quản lý kết quả học tập đến từng học
                                        sinh nhanh nhất</a></li>
                                    <li class="title2"><a>Tạo đề theo ma trận nhanh, đơn giản từ kho đề câu
                                        hỏi đã được số hóa sẵn</a></li>
                                </ul>
                            </div>
                            <div style="text-align: center">
                                <button @click="login" title="Tạo lớp học" class="yo-button">TẠO LỚP HỌC</button>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <div class="row" style="display: flex;justify-content: space-between">
                            <div class="icon_item">
                                <a href="#" id="co1">
                                    <img src="/home/images/qldshv.png"/>
                                    <span>QUẢN LÝ DANH SÁCH<br>HỌC VIÊN</span>
                                </a>
                            </div>
                            <div class="icon_item">
                                <a href="#" id="co2">
                                    <img src="/home/images/taolophoc.png"/><span>TẠO LỚP HỌC</span></a>
                            </div>
                            <div class="icon_item">
                                <a href="#" id="co3"><img
                                        src="/home/images/taodebtkt.png"/><span>TẠO ĐỀ BÀI TẬP,<br>BÀI KIỂM TRA</span></a>
                            </div>
                            <div class="icon_item">
                                <a href="#" id="co4"><img src="/home/images/giaobaituluantn.png"/><span>GIAO BÀI TỰ LUẬN<br>& TRẮC NGHIỆM</span></a>
                            </div>

                            <div class="icon_item">
                                <a href="#" id="co5"><img src="/home/images/chambai.png"/><span>CHẤM BÀI ONLINE<br>& OFFLINE</span></a>
                            </div>
                            <div class="icon_item">
                                <a href="#" id="co6">
                                    <img src="/home/images/guibaocao.png"/>
                                    <span>GỬI BÁO CÁO</span>
                                </a>
                            </div>
                            <div class="icon_item">
                                <a href="#" id="co7"><img
                                        src="/home/images/thaoluanlophoc.png"><span>THẢO LUẬN LỚP HỌC</span></a>
                            </div>
                        </div>

                    </v-flex>
                </v-layout>
            </div>
        </div>
        <div class="container_yo" style="margin-top:50px;margin-bottom: 50px">
            <v-layout wrap>
                <v-flex xs12 sm12 md6 lg 6 xl6>
                    <div class="item-hs">
                        <p class="title-1st primaryColor">Bạn là học sinh ?</p>
                        <p class="content-1st">Nhận bài tập, làm bài và nộp cho giáo viên online và offline một cách
                            linh hoạt</p>
                    </div>
                    <div style="text-align: center">
                        <button class="yo-button" @click="login">THAM GIA LỚP HỌC</button>
                    </div>
                </v-flex>
                <v-flex xs12 sm12 md6 lg 6 xl6 class="hideInMobile">
                    <div class="item thpt" style="overflow: hidden">
                        <a href="#"><img style="width: 90%" src="/home/images/anh2.png"></a>
                    </div>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex>
                    <div class="row primaryColor" style="display: flex;justify-content: space-between">
                        <div class="icon_item">
                            <a href="" title="Tham gia lớp học">
                                <img src="/home/images/thamgialophoc.png" alt="Tham gia lớp học"/>
                                <span class="primaryColor">NHẬN BÀI TẬP TỰ LUẬN<br>& TRẮC NGHIỆM</span>
                            </a>
                        </div>
                        <div class="icon_item">
                            <a href="" title="Làm bài tập tự luân & trắc nghiệm">
                                <img src="/home/images/lambaituluantn.png"
                                     alt="Làm bài tập tự luận và trắc nghiệm"/>
                                <span class="primaryColor">LÀM BÀI TỰ LUẬN<br>& TRẮC NGHIỆM</span>
                            </a>
                        </div>
                        <div class="icon_item">
                            <a href="" title="Nhận báo cáo">
                                <img src="/home/images/nhanbc.png" alt="Nhận báo cáo"/>
                                <span class="primaryColor">NHẬN BÁO CÁO</span>
                            </a>
                        </div>
                        <div class="icon_item">
                            <a href="" title="Hỏi bài giáo viên">
                                <img src="/home/images/thaoluanlop.png" alt="Thảo luận lớp"/>
                                <span class="primaryColor">THẢO LUẬN LỚP HỌC</span>
                            </a>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </div>
        <div class="container_yo" style="margin-top:50px;margin-bottom: 50px">
            <v-layout wrap>
                <v-flex xs12 sm12 md6 lg6 xl6 class="hideInMobile" style="overflow: hidden">
                    <div class="item registration">
                        <a href="#"><img style="width: 90%" src="/home/images/anh4.png"></a>
                    </div>
                </v-flex>

                <v-flex xs12 sm12 md6 lg6 xl6>
                    <div class="title-dk">
                        <div style="text-align: left">
                            <p class="title-1st" style="font-weight: bold">GIÁO VIÊN ĐĂNG KÝ ĐỂ NHẬN TƯ VẤN & DEMO!
                            </p>
                            <p class="content-1st">Hãy liên hệ với chúng tôi để được tư vấn & demo trực tiếp miễn phí
                                giải
                                pháp Yoclass.</p>
                        </div>
                        <form>
                            <v-layout class="form-group">
                                <input type="text" name="" class="form-control"
                                       placeholder="     Tên trường/trung tâm bạn giảng dạy?">
                            </v-layout>
                            <v-layout class="form-group">
                                <input type="text" name="" class="form-control"
                                       placeholder="     Số điện thoại của bạn?">
                            </v-layout>
                            <v-layout class="form-row">
                                <v-flex xs5 sm5 md5 lg5 xl5>
                                    <input type="text" class="form-control" id="email"
                                           placeholder="     Tỉnh/thành phố?"/>
                                </v-flex>
                                <v-flex xs2 sm2 md2 lg2 xl2></v-flex>
                                <v-flex xs5 sm5 md5 lg5 xl5>
                                    <input type="text" class="form-control" placeholder="     Tên của bạn?">
                                </v-flex>
                            </v-layout>
                            <div style="text-align: center">
                                <button class="yo-button" href="#">ĐẶT LỊCH TƯ VẤN & DEMO</button>
                            </div>
                        </form>
                    </div>
                </v-flex>
            </v-layout>
        </div>
        <footer id="footer" class="clearfix">
            <div class="container_yo">
                <v-layout>
                    <v-flex xs4 sm4 md4 lg4 xl4>
                        <div class="footer-logo">
                            <a class="logo-image" href="" title="">
                                <img src="/home/images/logo-footer.png" alt="logo footer">
                            </a>
                        </div>
                    </v-flex>
                    <v-flex xs8 sm8 md8 lg8 xl8 id="menu-footer" class="col-md-8 col-sm-8">
                        <v-layout wrap>
                            <v-flex>
                                <div class="col-md-5 col-sm-5">
                                    <div style="text-align: left">
                                        <p class="primaryColor">YOCLASS</p>
                                        <ul>

                                            <li><a href="#">Giải pháp</a></li>
                                            <li><a href="#">Điều khoản sử dụng</a></li>
                                            <li><a href="#">Chính sách bảo mật</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </v-flex>
                            <v-flex>
                                <div style="text-align: left">
                                    <p class="primaryColor">LIÊN HỆ VỚI CHÚNG TÔI</p>
                                    <ul style="list-style-type: none; padding-left: 0px">
                                        <li style=""><a>
                                            <v-icon dark>location_on</v-icon>
                                            Tòa nhà JoyHouse, Lô B2/D21<br>
                                            Khu ĐTM Cầu giấy, Dịch Vọng Hậu, Cầu Giấy, HN</a></li>
                                        <li><a>
                                            <v-icon dark>smartphone</v-icon>
                                            096 881 8899</a></li>
                                    </ul>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>

            </div>
            <div id="copyring">
                Copy Right 2020. Interland. Jsc
            </div>
        </footer>
        <div id="scroll_top" class="scrollToTop active" style="display:block;" @click="toTop">&nbsp;</div>
    </v-app>
</template>

<script>
    import VueGridLayout from 'vue-grid-layout';
    import {router} from '@/router';
    import axios from "axios";
    import {format, subDays} from 'date-fns';
    import {CrudService} from "@/services";
    import DualListBox from "dual-listbox-vue";
    import "dual-listbox-vue/dist/dual-listbox.css";
    import AppFooter from "../components/layout/AppFooter";

    export default {
        components: {
            AppFooter,
            GridLayout: VueGridLayout.GridLayout,
            GridItem: VueGridLayout.GridItem,
            DualListBox
        },
        data() {

            return {
                classes: [
                    {
                        url: 'https://yolearn.vn/uploads/yolearn/1550821579.jpg',
                        name: 'Bài 3: Giải bài toán bằng cách lập hệ phương trình (phần 1)',
                        teacher: 'DƯƠNG ANH'
                    },
                    {
                        url: 'https://yolearn.vn/uploads/yolearn/1550723577.jpg',
                        name: 'Bài 1: Kim loại kiềm và hợp chất của kim loại kiềm',
                        teacher: 'Mai Nguyễn'
                    },
                    {
                        url: 'https://yolearn.vn/uploads/yolearn/1550723683.jpg',
                        name: 'Bài 3: Giải bài toán bằng cách lập hệ phương trình (phần 1)',
                        teacher: 'MAI TRANG'
                    },
                    {
                        url: 'https://yolearn.vn/uploads/yolearn/1542871476.jpg',
                        name: 'HÓA HỌC HỮU CƠ LỚP 11',
                        teacher: 'THÚY NGA'
                    },
                    {
                        url: 'https://yolearn.vn/uploads/yolearn/5ba6228b387fe.jpg',
                        name: 'Bài 1: Kim loại kiềm và hợp chất của kim loại kiềm',
                        teacher: 'HỒNG NHUNG'
                    },
                    {
                        url: 'https://yolearn.vn/uploads/yolearn/1564022487.jpg',
                        name: 'Bài 3: Giải bài toán bằng cách lập hệ phương trình (phần 1)',
                        teacher: 'VƯƠNG QUYỀN'
                    }
                ]
            };
        },

        methods: {
            login: function () {
                this.$router.push("/login");
            },

            register: function () {
                this.$router.push("/register");
            },
            toTop() {
                document.location.href = '#';
            }
        },
        watch: {},
        mounted() {
        },
        updated() {
        },
        created() {
            //window.location.href = process.env.VUE_APP_FRONTEND_URL+ "/home/home.html";
            window.onscroll = (ev) => {
                ////console.log(this.activeTab);
                ////console.log(window.innerHeight + window.scrollY);
                ////console.log(document.body.offsetHeight);
                let menu = document.getElementById("menu-scroll");
                if (window.scrollY > 0) {
                    menu.classList.add("menu_sticker");
                    document.getElementById("scroll_top").style.display = "block";
                } else {
                    menu.classList.remove("menu_sticker");
                    document.getElementById("scroll_top").style.display = "none";
                }
            };
        },
    };
</script>
<style scoped>
    .row {
        display: flex;
        flex: 1 1 auto;
        flex-wrap: wrap;
        /*
                align-items: center;
                text-align: center;
        */
        text-align: center;
        justify-content: center;
    }

    .hotClass {
        text-align: center;
        font-size: 17px;
    }

    .hotClass h3 {
        font-size: 14px;
    }

    .hotClass a {
        display: inline-block;
        max-height: 400px;
        width: 400px;
        margin: 5px 5px 5px 5px;
        text-align: left;
    }

    .hotClass img.classCover {
        width: 100%;
        border-radius: 5px;
    }
</style>